import { ref } from "vue";
import { useSnackbarStore } from "@/store/snackbar.store";
import { Response } from "@/api/client";

export function useNotFound() {
  const entityNotFound = ref(false);
  const snackbarStore = useSnackbarStore();

  function notFound(): void {
    entityNotFound.value = true;
  }

  function validateEntityResponse<T>(response: Response<T>): boolean {
    if (!response.success) {
      if (response.status === 404) {
        notFound();
      } else if (response.error) {
        snackbarStore.showSnackbarError(response.error.message);
      }
      return false;
    }
    return true;
  }

  return {
    entityNotFound,
    notFound,
    validateEntityResponse,
  };
}
